import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ToolsService } from '../../services/tools/tools.service';

@Component({
  selector: 'ags-kendo-dropdown-treeview',
  templateUrl: './kendo-dropdown-treeview.component.html',
  styleUrls: ['./kendo-dropdown-treeview.component.scss']
})
export class KendoDropdownTreeviewComponent implements OnInit {
  @Input() public textFielName = 'libelle';
  @Input() public valueFielName = '';
  @Input() public childrenListName = 'children';

  @Input() public data: any[];
  @Input()
  public set value(val) {
    this.selectedItem = this.toolsService.findInHierarchyTab<any>(
      this.data,
      elem => {
        if (this.valueFielName === '') {
          return elem === val;
        }
        return `${elem[this.valueFielName]}` === `${val}`;
      },

      this.childrenListName
    );

    // this.selectedItem = this.data.find(elem => {
    //   if (this.valueFielName === '') {
    //     return elem === val;
    //   }
    //   return `${elem[this.valueFielName]}` === `${val}`;
    // });
  }
  @Output() public valueChange = new EventEmitter();

  public selectedItem;

  @ViewChild('dropdownlist') public dropdownlist: any;
  @ViewChild('myfunckingtreeview') public treeview: any;

  public listOpened = false;
  private _selected: any[] = [];
  public treeListStyle;

  public get selectedKeys() {
    return this._selected;
  }
  public set selectedKeys(value: string[]) {
    const treeSelectIndexes = value[0].split('_');
    let treeSelectItem: any = {};

    treeSelectItem[this.childrenListName] = [];
    treeSelectItem[this.childrenListName].push(...this.data);

    for (let index = 0; index < treeSelectIndexes.length; index++) {
      const treeSelectIndex = parseInt(treeSelectIndexes[index], 10);
      treeSelectItem = treeSelectItem[this.childrenListName][treeSelectIndex];
    }

    this.selectedItem = treeSelectItem;
    this.valueChange.emit(this.valueFielName ? this.selectedItem[this.valueFielName] : this.selectedItem);
    this.listOpened = false;
    this._selected = value;
  }

  constructor(private sanitizer: DomSanitizer, private toolsService: ToolsService) {
    this.treeListStyle = this.sanitizer.bypassSecurityTrustStyle(`
      position: absolute; top: 0; left: 0; background-color: white; min-width: 100%; z-index: 666;
      max-height: 30em; overflow: auto;
    `);
  }

  ngOnInit() {
    if (this.value) {
      this.selectedItem = this.data.find(elem => `${elem[this.valueFielName]}` === `${this.value}`);
    }
  }

  toggleDropdown() {
    if (this.dropdownlist) {
      this.dropdownlist.toggle(false);
      this.listOpened = !this.listOpened;
      if (this.listOpened) {
        setTimeout(() => {
          this.treeview.focus(this._selected[0]);
        });
      }
    }
  }

  onFocusLost() {
    setTimeout(() => {
      this.listOpened = false;
    }, 160);
  }
}
